import { ReservationsState } from 'types/app/reservations';

export const reservationsInitialState: ReservationsState = [];
